import { render, staticRenderFns } from "./layout-empty.vue?vue&type=template&id=26963266&scoped=true&"
import script from "./layout-empty.vue?vue&type=script&lang=js&"
export * from "./layout-empty.vue?vue&type=script&lang=js&"
import style0 from "./layout-empty.vue?vue&type=style&index=0&id=26963266&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26963266",
  null
  
)

export default component.exports